import React, { useState } from 'react';
import { Form, Input, Button, DatePicker, Layout, Card, Typography, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { dangKyKham } from '../services/publicService';
import dayjs from 'dayjs';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const DangKyOnline: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values: any) => {
        setLoading(true);
        try {
            const payload = {
                ...values,
                namSinh: parseInt(values.namSinh, 10),
                ngayDangKyKham: values.ngayDangKyKham.toISOString(),
            };

            await dangKyKham(payload);

            // Navigate to success page with form data, ensuring date is a string
            navigate('/dang-ky-thanh-cong', { state: { ...values, ngayDangKyKham: values.ngayDangKyKham.toISOString() } });


        } catch (error: any) {
            if (error.response) {
                if (error.response.status === 429) {
                    notification.error({
                        message: 'Lỗi',
                        description: 'Bạn gửi quá nhanh, xin hãy chờ và thử lại sau.',
                        placement: 'topRight',
                    });
                } else if (error.response.status === 400) {
                    // Handle validation errors from the backend
                    const validationErrors = error.response.data.errors;
                    const errorDescription = Object.values(validationErrors).flat().join('\n');
                    notification.error({
                        message: 'Thông tin không hợp lệ',
                        description: <pre>{errorDescription}</pre>,
                        placement: 'topRight',
                    });
                } else {
                    notification.error({
                        message: 'Lỗi máy chủ',
                        description: 'Đã có lỗi xảy ra. Vui lòng thử lại sau.',
                        placement: 'topRight',
                    });
                }
            } else {
                notification.error({
                    message: 'Lỗi kết nối',
                    description: 'Không thể kết nối đến máy chủ. Vui lòng kiểm tra lại đường truyền.',
                    placement: 'topRight',
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
                <Card style={{ width: '100%', maxWidth: '600px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                        <img src="/logo.png" alt="Logo" style={{ width: '100px', height: 'auto', marginBottom: '20px' }} />
                        <Title level={2}>Đăng Ký Khám Bệnh Từ Xa</Title>
                        <Paragraph style={{ marginTop: '-15px', marginBottom: '20px' }}>
                            Quý khách vui lòng điền các thông tin cần thiết và ngày muốn khám vào sau đó bấm Đăng ký, xin cảm ơn!
                        </Paragraph>
                    </div>
                    <Form
                        name="dang_ky_online"
                        onFinish={onFinish}
                        layout="vertical"
                        requiredMark="optional"
                    >
                        <Form.Item
                            name="tenBn"
                            label="Họ và Tên"
                            rules={[{ required: true, message: 'Vui lòng nhập họ và tên!' }]}
                        >
                            <Input placeholder="Nguyễn Văn A" />
                        </Form.Item>

                        <Form.Item
                            name="namSinh"
                            label="Năm Sinh"
                            rules={[
                                { required: true, message: 'Vui lòng nhập năm sinh!' },
                                { type: 'number', transform: value => Number(value), message: 'Năm sinh phải là số' },
                                { validator: (_, value) => 
                                    value && value > 1900 && value <= new Date().getFullYear() 
                                    ? Promise.resolve() 
                                    : Promise.reject(new Error('Năm sinh không hợp lệ'))
                                }
                            ]}
                        >
                            <Input type="number" placeholder="1990" />
                        </Form.Item>

                        <Form.Item
                            name="sdt"
                            label="Số Điện Thoại"
                            rules={[{ required: true, message: 'Vui lòng nhập số điện thoại!' }]}
                        >
                            <Input placeholder="09xxxxxxxx" />
                        </Form.Item>

                        <Form.Item
                            name="diaChi"
                            label="Địa chỉ"
                            rules={[{ required: true, message: 'Vui lòng nhập địa chỉ!' }]}
                        >
                            <Input placeholder="Ví dụ: Xóm 1, xã Diễn Kỷ, huyện Diễn Châu, tỉnh Nghệ An" />
                        </Form.Item>

                        <Form.Item
                            name="ngayDangKyKham"
                            label="Ngày Đăng Ký Khám"
                            rules={[{ required: true, message: 'Vui lòng chọn ngày đăng ký khám!' }]}
                        >
                            <DatePicker
                                showTime
                                format="DD/MM/YYYY HH:mm"
                                style={{ width: '100%' }}
                                disabledDate={(current) => {
                                    const today = dayjs().startOf('day');
                                    const sevenDaysLater = dayjs().add(7, 'day').endOf('day');
                                    return current && (current.isBefore(today) || current.isAfter(sevenDaysLater));
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name="lyDoDenKham"
                            label="Lý Do Đến Khám"
                            rules={[{ required: true, message: 'Vui lòng nhập lý do đến khám!' }]}
                        >
                            <TextArea rows={4} placeholder="Ví dụ: Đau đầu, chóng mặt..." />
                        </Form.Item>

                        <Form.Item
                            name="ghiChu"
                            label="Ghi Chú (nếu có)"
                        >
                            <TextArea rows={2} placeholder="Thông tin bổ sung" />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
                                Đăng Ký
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Content>
        </Layout>
    );
};

export default DangKyOnline;
